import React from "react";
import MainHeader from "../../components/mainheader";
import MainContainer from "../../components/maincontainer";
import SelectInput from "../../components/inputs/selectinputs";
import UserActivityTable from "../../components/tables/user-activity-table";

const UserActivities = () => {
  const Headers = ["ID", "Date", "details", "coins"];
  const tableData = [
    {
      id: "25",
      date: "26/12/2008",
      details: "Lorep ipsum",
      coins_used: "50 coins",
    },
    {
      id: "25",
      date: "26/12/2008",
      details: "Lorep ipsum",
      coins_used: "50 coins",
    },
    {
      id: "25",
      date: "26/12/2008",
      details: "Lorep ipsum",
      coins_used: "50 coins",
    },
    {
      id: "25",
      date: "26/12/2008",
      details: "Lorep ipsum",
      coins_used: "50 coins",
    },
  ];
  return (
    <div>
      <MainHeader text={"User Activity"} />
      <MainContainer>
        <h2 className="tw-text-xl tw-text-main tw-font-normal work">
          Kaytwo's Activity
        </h2>
        <div className="tw-mt-5 tw-w-80">
          <SelectInput label={"Choose Category"}>
            <option value="monthly">Monthly</option>
            <option value="monthly">Monthly</option>
            <option value="monthly">Monthly</option>
          </SelectInput>
        </div>
        <div className="tw-mt-10">
          <UserActivityTable data={tableData} headers={Headers} />
        </div>
      </MainContainer>
    </div>
  );
};

export default UserActivities;
